import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectCamaraGarita, selectGarita } from "src/redux/slices/complexSlice"
import axiosInstance from "src/utils/axios"

const AlertGarita = () => {
  const currentGarita = useSelector(selectCamaraGarita)
  const conjunto = useSelector(state => state.complex.complex)
  const dispatch = useDispatch()
  const [showAlert, setShowAlert] = useState(false)
  const [garitas, setGaritas] = useState([])

  const handleConfirmGarita = numGarita => {
    dispatch(selectGarita(numGarita))
    setShowAlert(false)
  }

  useEffect(() => {
    if (conjunto.id) {
      axiosInstance
        .get("api/camaras_bitacora/", { params: { id_conjunto: conjunto.id } })
        .then(({ data }) => {
          if (data.count > 1) {
            const groupGaritas = data.results.map(
              garita => garita.camara_garita
            )
            setGaritas(groupGaritas)
            setShowAlert(true)
          } else {
            handleConfirmGarita(data.results?.[0]?.camara_garita || null)
          }
        })
        .catch(() => {})
    }
  }, [conjunto.id])

  if (garitas.length <= 0 || Boolean(currentGarita)) {
    return null
  }

  return (
    <Dialog
      open={showAlert}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown
      scroll="paper"
    >
      <DialogTitle>CONJUNTO CON MULTIPLES GARITAS</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Para continuar debe seleccionar la garita en la que se encuentra:
        </DialogContentText>
        <Grid container spacing={2} justifyContent="space-between">
          {garitas.map(garita => (
            <Grid item xs={12} md={6} key={garita}>
              <Button
                fullWidth
                color="primary"
                variant="outlined"
                onClick={() => handleConfirmGarita(garita)}
              >
                {garita}
              </Button>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default AlertGarita
